<template>
  <div class="empty">
    <img :src="require('./../../../assets/images/cart-empty.png')" />
    <p>{{TLang('您的购物车还是空的哦','list')}}</p>
    <p>{{TLang('赶紧去逛逛','list')}}</p>
    <div>
      <a href='javascript:void(0)'  @click="goToPage">{{ hasLife ? TLang('去优选首页','user') : TLang('去商城首页','user') }}</a>
    </div>
  </div>
</template>

<script>
import { getFindUsableList, getLogo } from '@fetch';
import { unionFlag, gioClickHandle } from '@utils';
export default {
  name: 'Empty',
  data(){
    return {
      hasLife: true,
      homeIndex: '',
    };
  },
  mounted(){
    if(unionFlag() || sessionStorage.getItem('dffl_union')){
      getFindUsableList({
        union: unionFlag() || sessionStorage.getItem('dffl_union'),
      }).then(res => {
        if(res.length){
          const hasLife = res.filter((item) => item.code === 'Shopping');
          this.hasLife = Boolean(hasLife.length);
        }
      });
      getLogo({
        unionFlag: 1,
        union: unionFlag() || sessionStorage.getItem('dffl_union'),
      }).then(res => {
        this.homeIndex = res.homeIndex;
      });
    }
  },
  methods: {
    goToPage(){
      this.changeGio('去优选首页','去优选首页');
      const url = this.hasLife ? '/shop/home' : this.homeIndex;
      setTimeout(() => {
        window.df_sdk_common.location.href = url;
      }, 10);
    },
    changeGio(df_modulename, df_elementname) {
      try {
        let channel = '';
        const params = {
          df_channle: channel,
          df_modulename: df_modulename,
          df_elementname: df_elementname,
        };
        gioClickHandle('DF_elementClick', params, 'cart');
      } catch (e) {
        console.log('埋点失败:', e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.empty {
  width: 100%;
  text-align: center;
  img {
    width: 50%;
    margin-top: 50px;
  }
  p {
    font-size: 15px;
    color: #999;
    margin-top: 10px;
  }
  div {
    margin-top: 20px;
    a {
      width: 144px;
      height: 40px;
      display: inline-block;
      background: linear-gradient(
        315deg,
        rgba(92, 180, 236, 1) 0%,
        rgba(61, 150, 226, 1) 100%
      );
      border-radius: 4px;
      text-align: center;
      line-height: 40px;
      font-weight: bold;
      color: #fff;
    }
  }
}
</style>
